<template>
  <div class="w-full">
    <div class="w-full">
      <DataTable>
        <template #tableHeaders>
          <tr class="py-2 ps-3 border border-brand-gray-300 text-start">
            <th
              v-for="item in tableHeaders"
              :key="item.value"
              class="p-1 border border-gray-100 text-gray-800"
            >
              {{ item.label }}
            </th>
          </tr>
        </template>
        <template #tableBody>
          <tbody
            class="odd:bg-brand-gray-150"
            v-for="(request, index) in requestDraftCollections"
            :key="index"
          >
            <slot name="tableRow" :request="request" :index="index" />
            <slot name="moreTableRow" :request="request" :index="index" />
          </tbody>
        </template>
        <template #emptyBody>
          <tr v-if="!requestDraftCollections?.length" class="bg-brand-gray-100">
            <td
              class="text-gray-600 font-semibold py-4 px-3 text-center"
              :colspan="tableHeaders?.length"
            >
              {{ $t('NoRecordFound') }}
            </td>
          </tr>
        </template>
      </DataTable>
    </div>
    <div
      class="mt-4 w-full flex flex-wrap justify-between gap-4"
      v-if="tableFooter && pagination.totalItemCount >= 5"
    >
      <PageSelector
        @seleted="selectedNumberOfRow"
        :pageLength="pageLength"
        :pagination="pagination"
        :currentPage="paginatorConfig.currentPage"
      />
      <Paginate
        :page-count="paginatorConfig.pageCount"
        :page-range="paginatorConfig.itemsPerPage"
        :click-handler="onPageClick"
        :prev-text="'‹'"
        :next-text="'›'"
        :first-last-button="true"
        container-class="pagination"
        first-button-text="«"
        last-button-text="»"
        :force-page="paginatorConfig.currentPage"
      >
      </Paginate>
      <PaginationInput
        v-model="modalValue"
        :paginatorConfig="paginatorConfig"
        mask="##"
        @change="onInputChange($event)"
      />
    </div>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref, watchEffect } from 'vue'

import DataTable from '@/components/DataTable/index.vue'
import Paginate from 'vuejs-paginate-next'
import PageSelector from '@/components/PageSelector/index.vue'
import PaginationInput from '@/components/PageSelector/PaginationInput.vue'

const emits = defineEmits(['onPageClick', 'seleted', 'checked', 'checkOut', 'checkIn', 'onChange'])

const props = defineProps({
  tableData: {
    type: Array,
    default: () => []
  },
  tableHeaders: {
    type: Array,
    default: () => []
  },
  initialValues: {
    type: Object,
    default: () => {}
  },
  pageLength: {
    type: Number,
    required: true
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  tableFooter: {
    type: Boolean,
    default: true
  }
})

const requestDraftCollections = ref([])
const modalValue = ref()

const pagination = ref({
  numberOfPages: 0,
  totalItemCount: 0
})

const paginatorConfig = reactive({
  totalItemCount: 0,
  itemsPerPage: 10,
  currentPage: 1,
  pageCount: 0
})

const selectedNumberOfRow = (num) => {
  paginatorConfig.currentPage = 1
  paginatorConfig.pageCount = pagination.value.numberOfPages
  paginatorConfig.itemsPerPage = num;
  emits('selected', num)
}

const onInputChange = (event) => {
  const currentPage = +event.target.value
  onPageClick(currentPage)
}

const onPageClick = (pageNum) => {
  paginatorConfig.currentPage = pageNum
  modalValue.value = paginatorConfig.currentPage
  paginatorConfig.pageCount = pagination.value.numberOfPages
  requestDraftCollections.value = props.tableData?.collection
  emits('onPageClick', pageNum)
}

watchEffect(async () => {
  if (props.tableData?.collection) {
    requestDraftCollections.value = props.tableData?.collection
    pagination.value.numberOfPages = Math.ceil(
      props.tableData?.numberOfRecords / ( paginatorConfig.itemsPerPage || props.initialValues?.pageSize || 0)
    )

    pagination.value.totalItemCount = props.tableData?.numberOfRecords
    paginatorConfig.pageCount = pagination.value.numberOfPages
    modalValue.value = paginatorConfig.currentPage
  }
})

onMounted(() => {
  modalValue.value = paginatorConfig.currentPage
})
</script>

<style></style>
